///
/// EarthBrowser
///
/// Created by Matt Giger on 8/19/2024
/// Copyright (c) 2024 Geodata Labs
///

import { FetchLoader } from "@/earthbrowser/utils/loaders/FetchLoader"
import { CacheTable } from "@/earthbrowser/database/tables/CacheTable"
import { Database } from "@/earthbrowser/database/Database"

/**
 * DataLoader class extends FetchLoader to handle data loading and caching.
 */
export class DataLoader extends FetchLoader {

	/**
	 * Overrides the load method to implement caching functionality.
	 * @returns A promise that resolves to the loaded data as an ArrayBuffer or undefined if loading fails.
	 */
	override async load(): Promise<ArrayBuffer | undefined> {
		if(!Database.cacheAvailable) {
			// If database is not available, load data directly
			const data = await super.load()
			return data

		} else {

			// Try to load cached data first
			const cachedData = await CacheTable.get(this.url)

				// Return cached data if available
			if(cachedData) {
				return cachedData
			} else {
				// Load data from source if not cached
				const data = await super.load()
				if(data) {
					// Cache the newly loaded data
					CacheTable.set(this.url, Date.now() + this._lifetime, data)
					return data
				}
			}
			return undefined
		}
	}

	public purgeFromCache(): void {
		CacheTable.remove(this.url)
	}
}